// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import { Row } from 'antd';
import Slider from 'react-slick';
import { LogoLogin } from 'assets';
import SlideImage1 from 'assets/art_image1.jpg';
import SlideImage2 from 'assets/art_image2.jpg';
import SlideImage3 from 'assets/art_image3.jpg';
import SlideImage4 from 'assets/art_image4.jpg';

import { OPTION_LIST, settings } from './constant';
import * as S from './styled';

const Footer = () => {
  return (
    <S.FooterWrapper>
      <Slider {...settings} slidesToShow={window.innerWidth > 425 ? 3.5 : 1.2}>
        <img src={SlideImage1} alt="" />
        <img src={SlideImage2} alt="" />
        <img src={SlideImage3} alt="" />
        <img src={SlideImage4} alt="" />
      </Slider>
      <Row align="center" justify="center">
        <LogoLogin />
      </Row>
      <Row align="center" justify="center">
        <S.OptionWarraper>
          {OPTION_LIST?.map((item, index) => {
            return (
              <li key={index}>
                <a target="_blank" rel="noreferrer" href={item.link}>
                  {item.content}
                </a>
              </li>
            );
          })}
        </S.OptionWarraper>
      </Row>
      <Row align="center" justify="center">
        <S.CoppyRigthWarraper>
          <p>Copyright © </p>
          <p>At Home Co.,Ltd.</p>
        </S.CoppyRigthWarraper>
      </Row>
    </S.FooterWrapper>
  );
};

export default Footer;
